import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { useLocal } from "hooks";
import { Button, FormControl, TextField } from "_imports/mui";
import { useGetIsUserIdExistMutation } from "store/api";
import Header from "Header";

import { FROM_SIGN_IN, Key, Paths } from "../constants";

import "App.css";
import "./SignIn.css";

const SignIn = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const userLocal = useLocal(Key.USER_ID);

  const [getIsUserIdExist] = useGetIsUserIdExistMutation();

  const [savedUserId, setSavedUserId] = useState(userLocal.getItem());
  const [userId, setUserId] = useState<string>("");
  const [errorHelperText, setErrorHelperText] = useState<string>("");

  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    sendRequest();
  };

  const sendRequest = async (userIdLocal = userId) => {
    if (userIdLocal.length === 0) {
      setErrorHelperText("Por favor, introduce un ID de usuario");
      return;
    }
    await getIsUserIdExist(userIdLocal)
      .unwrap()
      .then(() => {
        setErrorHelperText("");
        userLocal.setItem(userIdLocal);
        navigate(Paths.SUBMIT_ANSWERS, { replace: true });
      })
      .catch((err) => {
        let message: string;
        if (err.status === "FETCH_ERROR") {
          message = "No se puede alcanzar el servidor backend.";
        } else if (err.data?.detail != null) {
          message = err.data.detail;
        } else {
          message = "Error al iniciar sesión.";
        }
        enqueueSnackbar(message, {
          variant: "error",
        });
      });
  };

  return (
    <div className="sign-in">
      <Header />
      <div className="center sign-in-form" style={{ flexDirection: "column" }}>
        {savedUserId && typeof savedUserId === "string" && (
          <>
            <Button variant="text" onClick={() => sendRequest(savedUserId)}>
              Anteriormente has iniciado sesión con {savedUserId}. ¿Quieres
              reutilizarlo?
            </Button>
            <Button
              variant="text"
              onClick={() => {
                userLocal.removeItem();
                setSavedUserId("");
              }}
            >
              ¿Olvidarlo?
            </Button>
          </>
        )}
        <div className="center">
          <FormControl>
            <TextField
              id="outlined-basic"
              label="ID de usuario"
              variant="outlined"
              autoFocus
              autoComplete="on"
              margin="normal"
              error={errorHelperText.length > 0}
              helperText={errorHelperText}
              onChange={(e) => setUserId(e.target.value)}
            />
            <Button onClick={onSubmit} variant="contained">
              Iniciar sesión
            </Button>

            <Button variant="text">
              <Link
                to={Paths.CREATE_ACCOUNT}
                state={{ from: FROM_SIGN_IN }}
                style={{ textDecoration: "none" }}
              >
                ¿No tienes una cuenta? Crea una.
              </Link>
            </Button>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
